import '../colors.css';
import './footer-menus.css';
import './footer-menus.html.twig';
import './footer_map.png';

document.addEventListener('DOMContentLoaded', () => {
  // Append referrer to ticket URL, if applicable
  const ticketlink = document.getElementById('site-ticket-link');
  if (
    ticketlink &&
    ticketlink.href.indexOf('&ref=') === -1 &&
    document.referrer
  ) {
    const referrer = encodeURIComponent(document.referrer).slice(0, 255);
    ticketlink.href += `&ref=${referrer}`;
  }
});
